import { z } from 'zod';

// Contrato de la administración de usuarios validado con Zod (ENG-VAL-01): un
// drift del backend cae al estado de error de la query, no revienta en render.

export const userCompanySchema = z.object({
  id: z.string(),
  name: z.string(),
  isPrimary: z.boolean(),
});
export type UserCompany = z.infer<typeof userCompanySchema>;

// `status` es string libre (no enum): un estado nuevo del backend no debe tumbar la
// pantalla; se muestra con una etiqueta de reserva (userStatusLabel).
export const adminUserSchema = z.object({
  id: z.string(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  displayName: z.string().nullable(),
  status: z.string(),
  roles: z.array(z.object({ code: z.string(), name: z.string() })),
  /** Empresas (fuente: LMS) que quien consulta puede ver, primaria primero. */
  companies: z.array(userCompanySchema),
  /** Empresas del usuario fuera de las visibles: se cuentan, no se nombran. */
  otherCompaniesCount: z.number().int().nonnegative(),
});
export type AdminUser = z.infer<typeof adminUserSchema>;

export const adminUsersResponseSchema = z.object({
  success: z.literal(true),
  data: z.array(adminUserSchema),
  meta: z.object({ next_cursor: z.string().nullable() }),
});
export type AdminUsersPage = z.infer<typeof adminUsersResponseSchema>;
